import React, { useEffect, useMemo, useState } from 'react';
import { ExternalMessage, CorpUnreadMessage } from '../container';
import { size, some } from '@libs/shared';
import { API } from '../../../constants';
import { post, getRequestUrl } from '../../../utils';
import { authModel } from '../../../models';

const useExternalMessage = () => {
    const [externalMessage, setExternalMessage] = useState<CorpUnreadMessage[]>();

    useEffect(() => {
        post<CorpUnreadMessage[]>(getRequestUrl(API.message.get_unread_tenant_list)).then(
            ({ data }) => {
                setExternalMessage(data ?? []);
            }
        );
    }, []);
    const renderExternalMessage = (key: string) => {
        return <ExternalMessage key={key} externalMessage={externalMessage ?? []} />;
    };

    const hasUnreadExternalMessage = useMemo(() => {
        return some(externalMessage, (item) => {
            const isCurrentCorp = item.tenant_id === authModel.tenantId;
            return item.has_unread && !isCurrentCorp;
        });
    }, [externalMessage]);

    return {
        isFetchingExternalMessage: !externalMessage,
        showExternalMessage: size(externalMessage) > 1,
        hasUnreadExternalMessage,
        renderExternalMessage
    };
};

export default useExternalMessage;
